export default __webpack_public_path__ + "static/media/header-instagram.e6de8a70.png";